<template>
  <main>
    <LoginSignup title="Sign Up" />
  </main>
</template>

<script>
import LoginSignup from "../components/LogInSignup/LoginSignup.vue";
export default {
  components: { LoginSignup },
};
</script>
